var render = function render(){var _vm=this,_c=_vm._self._c;return _c('async-table-action-button',{attrs:{"callback":_vm.ComfirmAndDelete,"label":_vm.trans('buttons.delete'),"grid":_vm.grid}},[_c('inline-svg',{attrs:{"url":require('../../../../images/actions/trash.svg'),"classes":"table-action-cell__icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }